import ITheme from "@/interfaces/iTheme";
import backgroundImage from "@assets/themes/winter/Winter-mockup-bkgd2.svg";

export class WinterTheme implements ITheme
{
    static Id = 'winter';
    id = WinterTheme.Id;

    name = 'Winter';

    colors = {
                application: '#553A97', //#051c29
                text: '#FFFFFF',
                confirm: '#A86636',
                secondary: '#62B4E4',

                // Challenge card colors
                solved: '#F66573',
                solvedText: '#000000',
                locked: "#0009",
                unsolved: '#C68A53',
                unsolvedText: '#000000',
                noMoreAttempts: '#F89D35',
                noMoreAttemptsText: '#000000',
                disabled: '#F89D35',
                disabledText: '#000000',

                windowBackground: '#000D',
                windowText: '#FFF',
                windowBorder: '#FFFFFF1F',

                tag: '#62B4E4',
                activeTab: '#62B4E4',
                dialogText: '#303030',
                dialogLink: '#553A97',
                dialogSuccessText: '#4CAF50',
                dialogFailureText: '#F44336',
                dialogIcon: '#553A97',
                success: '#4CAF50',
                warning: '#FF9800',

                // Table
                tableHeaderActionButtons: 'white',
                tableHeaderSelectAllButtons: '#62B4E4',

                //settings and bulk select checkboxes 
                checkedFill:'#A86636',
                settingsInputError: '#D83D3D',
                settingsInputErrorShadow: '#040509',

                // focus indicators
                focusVisibleIndicator:  '#A86636',

                // for heading / subheading/ nav / subnav accessible shadow
                backgroundImageColor: '#1D2944',

                actionButtonBackground: '#1D2944',
                actionButtonText: 'white',
             };
        
    fontFamily = "WDXL-Lubrifont-SC";
    landingFontFamily = "space_frigate";
    backgroundImage = backgroundImage;
    isDark = true;
}
